/* @flow */
import React from 'react';

type Props = {
  condition?: any,
  children?: React$Node,
};

type DefaultProps = {
  condition: any,
  children: React$Node,
};

export default class If extends React.PureComponent<Props> {
  static displayName = 'If';

  static defaultProps: DefaultProps = {
    condition: null,
    children: null,
  };

  render() {
    return this.props.condition ? React.Children.only(this.props.children) : null;
  }
}
